{
  "baseApiUrl": "https://catalog-api.dev.bemerri.com/api",
  "baseBlobUrl": "https://blob.dev.bemerri.com",
  "adClientId": "c0a83b7d-d1a1-4a86-af2a-1c75c528e1fd"
}
